import { useTranslation } from 'react-i18next'

import { ArrowRight, ArrowUDownLeft } from '@phosphor-icons/react'

import { Alert, Button, ButtonWithSpinner, Modal, Text } from '@reveni-io/reveni-ui'
import { Divider } from '@reveni-io/reveni-ui'

import DeliveryMethodList from './DeliveryMethodList/DeliveryMethodList'
import ShippingMethodList from './ShippingMethodList/ShippingMethodList'
import * as Styles from './styles'

const DeleteLocationModal = ({
  show,
  onClose,
  onDelete,
  associatedDeliveryMethods,
  associatedShippingMethods,
  deleting,
  locations,
  regions,
  changeLocationIdOfDeliveryMethod,
  changeLocationIdOfShippingMethod,
  isFormValid,
  locationToDelete,
}) => {
  const { t } = useTranslation()

  return (
    <Modal title={t('Eliminar ubicación')} show={show} onClose={onClose} size="l">
      <Styles.MainContainer>
        {(associatedDeliveryMethods?.length > 0 || associatedShippingMethods?.length > 0) && (
          <Text type="bodyMRegular">{t('Elige una nueva ubicación para sustituir la que vas a eliminar')}:</Text>
        )}
        {associatedDeliveryMethods?.length > 0 && (
          <>
            <Styles.AssociatedMethodsTitle>
              <ArrowUDownLeft size={24} />
              <Text type="titleS">{t('Métodos de devolución')}:</Text>
            </Styles.AssociatedMethodsTitle>
            <DeliveryMethodList
              deliveryMethods={associatedDeliveryMethods || []}
              locations={locations}
              regions={regions}
              changeLocationIdOfDeliveryMethod={changeLocationIdOfDeliveryMethod}
              locationToDelete={locationToDelete}
            />
            <Divider />
          </>
        )}
        {associatedShippingMethods?.length > 0 && (
          <>
            <Styles.AssociatedMethodsTitle>
              <ArrowRight size={24} />
              <Text type="titleS">{t('Envíos')}:</Text>
            </Styles.AssociatedMethodsTitle>
            <ShippingMethodList
              shippingMethods={associatedShippingMethods}
              locations={locations}
              regions={regions}
              locationToDelete={locationToDelete}
              changeLocationIdOfShippingMethod={changeLocationIdOfShippingMethod}
            />
            <Divider />
          </>
        )}
        <Alert type="warning">{t('Esta acción no se podrá deshacer más adelante. ¿Quieres continuar?')}</Alert>
        <Styles.ActionsContainer>
          <Button variant="outlined" onClick={onClose} fullWidth>
            {t('Cancelar')}
          </Button>
          <ButtonWithSpinner
            fullWidth
            loading={deleting}
            disabled={deleting || !isFormValid()}
            onClick={onDelete}
            defaultLabel={t('Confirmar y eliminar ubicación')}
            loadingLabel={t('Confirmar y eliminar ubicación')}
          />
        </Styles.ActionsContainer>
      </Styles.MainContainer>
    </Modal>
  )
}

export default DeleteLocationModal
